import EmailSelect from "./email-channel-email-select";
import ExhibitionTypeSelect from "./email-channel-exhibition-type-select";
import StatusSwitch from "./email-channel-status-switch";
import VisibilitySwitch from "./email-channel-visibility-switch";

const EmailChannelFormFields = {
  EmailSelect,
  ExhibitionTypeSelect,
  StatusSwitch,
  VisibilitySwitch,
};

export default EmailChannelFormFields;
